export default __webpack_public_path__ + "static/media/upmpost.8208d450.png";